import UserCircleIcon from '@flipster/react/icon/generated/UserCircleIcon';
import { Styles, css } from '@flipster/styled-system/css';
import { circle } from '@flipster/styled-system/patterns';

interface ProfileIconProps {
  profileIconUrl?: string;
  size: number;
  css?: Styles;
}

export const ProfileIcon = ({ profileIconUrl, size, css: cssProps }: ProfileIconProps) => {
  if (!profileIconUrl)
    return <UserCircleIcon size={size} className={css(circle.raw({ color: 'content.default.level-5' }), cssProps)} />;
  return (
    <img
      src={profileIconUrl}
      className={css(circle.raw({ bg: 'background.default.level-3' }), cssProps)}
      width={size}
      height={size}
      alt='Profile picture of this master trader'
    />
  );
};
